import React from 'react';
import { withRouter } from 'react-router-dom';
import { useSelector } from 'react-redux';

const RemeUpdate = props => {
  const userId = useSelector(store => store.auth.id);
  const userType = useSelector(store => store.auth.userType);
  return (
    <div 
      className="d-flex
                  flex-column
                  justify-content-center 
                  align-items-center 
                  forbidden text-white">
      <h1 className="text-center display-1 fw-bold">Actualización requerida</h1>
      <p>Estimado usuario, este es un recordatorio de actualización de datos; el sistema bloqueará su acceso de hacer caso omiso a está advertencia</p>
      <button className="btn btn-warning rounded-pill" onClick = {() => props.history.push(`/perfil-usuario/${userId}/${userType}`)}><i className="material-icons">history</i> Continuar</button> 
    </div>
  )
}

export default withRouter(RemeUpdate)
